<template>
  <div class="date-picker__container wd-min-h-max">
    <div ref="pickerContent" class="picker__content wd-flex wd-flex-col wd-justify-center wd-items-center">
      <div class="date-picker-wrapper wd-mx-4 wd-w-full">
        <!-- dayMode 是由地區和分類的 filter API response 取得的 -->
        <seven-day-picker v-if="dayMode === 0" v-model="filterDate" class="pt-5 px-6" />
        <v-date-picker
          v-else
          :model-value="filterDateObject"
          :min="minDate"
          :max="maxDate"
          color="orange50"
          full-width
          hide-header
          width="100%"
          @update:model-value="onDatePick"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SevenDayPicker from '@/components/page/categories/seven-day-picker'

let filterDebounce = null

export default {
  name: 'DatePicker',
  components: {
    SevenDayPicker,
  },
  props: {
    value: { type: Array, default: () => [] },
    isClear: { type: Boolean, default: false },
    dayMode: { type: Number, default: 0 },
    keyValue: { type: Array, default: () => [] },
  },
  emits: ['returnFilter', 'updateClearBtn'],
  data() {
    return {
      filterDate: this.value[0] || '',
    }
  },
  computed: {
    filterDateObject() {
      if (!this.filterDate) {
        return null
      }
      return this.$dayjs(this.filterDate).toDate()
    },
    minDate() {
      return this.$dayjs().subtract(1, 'day').toDate()
    },
    maxDate() {
      // dayMode: 0 是七天; 1 是三十天; 2 是一百八十天
      const result = this.dayMode === 1 ? this.$dayjs().add(30, 'day').format('YYYY-MM-DD') : this.$dayjs().add(180, 'day').format('YYYY-MM-DD')
      return this.$dayjs(result).toDate()
    },
    locale() {
      return this.$i18n.locale
    },
  },
  watch: {
    isClear(newVal) {
      if (newVal) {
        this.clearData()
        this.$emit('updateClearBtn', false)
      }
    },
    filterDate() {
      clearTimeout(filterDebounce)
      filterDebounce = setTimeout(() => {
        this.estimateTotalCount()
      }, 500)
    },
  },
  methods: {
    onDatePick(date) {
      this.filterDate = this.$dayjs(date).format('YYYY-MM-DD')
    },
    clearData() {
      this.filterDate = ''
    },
    checkActivated() {
      return !!this.filterDate
    },
    estimateTotalCount() {
      const filterDate = this.filterDate || false
      this.$emit('updateClearBtn', this.checkActivated())
      this.$emit('returnFilter', [filterDate, filterDate])
    },
  },
}
</script>

<style lang="scss" scoped>
.date-picker__container {
  max-height: 50vh;
  overflow-y: auto;

  @include xxs {
    max-height: 52vh;
  }
}
</style>
